"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Box = require("../../components/Box/Box");

var _Header = require("../../components/Header/Header");

var _Text = require("../../components/Text/Text");

var _Icons = _interopRequireDefault(require("../../components/Icons/Icons"));

var _Line = require("../../components/Line/Line");

var _Anchor = require("../../components/Anchor/Anchor");

var _Theme = require("../../Theme/Theme.variables");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n  text-decoration: none !important;\n  transition: all 0.2s ease;\n  will-change: box-shadow, background-color;\n  border: 1px solid ", ";\n  background-color: ", ";\n  .spacer {\n    flex-grow: 1;\n  }\n  img {\n    vertical-align: middle;\n    max-width: 100%;\n    height: auto;\n  }\n  h4,\n  h5,\n  p {\n    transition: all 0.2s ease;\n    will-change: color;\n  }\n  &:hover {\n    box-shadow: ", ";\n    h4,\n    h5,\n    p {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  text-decoration: none !important;\n  transition: all 0.2s ease;\n  will-change: box-shadow, background-color;\n  border: 1px solid ", ";\n  img {\n    vertical-align: middle;\n    max-width: 100%;\n    height: auto;\n  }\n  h4,\n  h5,\n  p {\n    transition: all 0.2s ease;\n    will-change: color;\n  }\n  &:hover {\n    box-shadow: ", ";\n    background-color: ", ";\n    h4,\n    h5,\n    p {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var AnchorCardGentux = (0, _styledComponents.default)(_Anchor.Anchor)(_templateObject(), function (props) {
  return (0, _Theme.variables)(props).primary;
}, function (props) {
  return (0, _Theme.variables)(props).shadows[3];
}, function (props) {
  return (0, _Theme.variables)(props).white;
}, function (props) {
  return (0, _Theme.variables)(props).textPrimary;
});
var AnchorCardMenguin = (0, _styledComponents.default)(_Anchor.Anchor)(_templateObject2(), function (props) {
  return (0, _Theme.variables)(props).grayLighter;
}, function (props) {
  return (0, _Theme.variables)(props).white;
}, function (props) {
  return (0, _Theme.variables)(props).shadows[3];
}, function (props) {
  return (0, _Theme.variables)(props).textPrimary;
});

var SalesCallout =
/*#__PURE__*/
function (_Component) {
  _inherits(SalesCallout, _Component);

  function SalesCallout() {
    _classCallCheck(this, SalesCallout);

    return _possibleConstructorReturn(this, _getPrototypeOf(SalesCallout).apply(this, arguments));
  }

  _createClass(SalesCallout, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.default.Fragment, null, this.props.theme.brand === 'menguin' ? _react.default.createElement(AnchorCardMenguin, {
        href: this.props.ctaUrl,
        display: "flex",
        className: "\n                tracker-callout-".concat(this.props.ctaPageName ? this.props.ctaPageName : 'page_not_provided', "-").concat(this.props.calloutId ? this.props.calloutId : 'calloutId_not_provided', "-20190408-093833\n              ")
      }, _react.default.createElement(_Box.Box, {
        style: {
          overflow: 'hidden',
          textAlign: 'right'
        },
        mb: 3
      }, _react.default.createElement("picture", {
        className: "lozad",
        "data-iesrc": this.props.image,
        "data-alt": this.props.imageAlt
      }, this.props.imageMobile && _react.default.createElement("source", {
        media: "(max-width: ".concat(parseInt(_Theme.breakpoints['xs'], 0) - 1 + 'px', " )"),
        srcSet: this.props.imageMobile
      }), _react.default.createElement("source", {
        srcSet: this.props.image
      }))), _react.default.createElement(_Box.Box, {
        px: [3, 3, 3, 3, 4, 4]
      }, _react.default.createElement(_Header.Header, {
        type: 4,
        textColor: "grayDarker",
        mb: 3
      }, this.props.headline), this.props.body && _react.default.createElement(_Text.Text, {
        small: true,
        textColor: "grayDark",
        style: {
          wordBreak: 'break-word',
          WebkitHyphens: 'auto'
        }
      }, this.props.body)), this.props.body && _react.default.createElement("div", {
        className: "spacer"
      }), this.props.ctaTitle && _react.default.createElement(_Box.Box, null, _react.default.createElement(_Line.Line, {
        mt: 4,
        lineColor: "grayLighter"
      }), _react.default.createElement(_Header.Header, {
        type: 6,
        style: {
          textAlign: 'right'
        },
        p: [3]
      }, _react.default.createElement(_Icons.default.ArrowRight, {
        color: "textPrimary",
        mr: 3
      }), this.props.ctaTitle))) : _react.default.createElement(AnchorCardGentux, {
        href: this.props.ctaUrl,
        display: "flex",
        className: "\n                tracker-callout-".concat(this.props.ctaPageName ? this.props.ctaPageName : 'page_not_provided', "-").concat(this.props.calloutId ? this.props.calloutId : 'calloutId_not_provided', "-20190408-093833\n              "),
        p: [3, 3, 3, 3, 4, 4]
      }, _react.default.createElement(_Box.Box, null, _react.default.createElement(_Header.Header, {
        type: 4,
        textColor: "grayDarker",
        mb: 3
      }, this.props.headline), this.props.body && _react.default.createElement(_Box.Box, null, _react.default.createElement(_Text.Text, {
        small: true,
        textColor: "grayDark",
        style: {
          wordBreak: 'break-word',
          WebkitHyphens: 'auto'
        }
      }, this.props.body)), this.props.body && _react.default.createElement(_Box.Box, null, _react.default.createElement(_Line.Line, {
        headlineDivider: true,
        my: [3, 3, 3, 4, 4, 4]
      })), this.props.ctaTitle && _react.default.createElement(_Header.Header, {
        type: 5,
        mb: 3
      }, _react.default.createElement(_Box.Box, {
        mr: 2,
        display: "inline"
      }, this.props.ctaTitle), _react.default.createElement(_Icons.default.ArrowRight, {
        color: "textPrimary",
        width: "12"
      }))), _react.default.createElement(_Box.Box, {
        mr: [-3, -3, -3, -3, -4, -4],
        mb: [-3, -3, -3, -3, -4, -4],
        style: {
          overflow: 'hidden',
          textAlign: 'right'
        }
      }, _react.default.createElement("picture", {
        className: "lozad",
        "data-iesrc": this.props.image,
        "data-alt": this.props.imageAlt
      }, this.props.imageMobile && _react.default.createElement("source", {
        media: "(max-width: ".concat(parseInt(_Theme.breakpoints['xs'], 0) - 1 + 'px', " )"),
        srcSet: this.props.imageMobile
      }), _react.default.createElement("source", {
        srcSet: this.props.image
      })))));
    }
  }]);

  return SalesCallout;
}(_react.Component);

var _default = (0, _styledComponents.withTheme)(SalesCallout);

exports.default = _default;